import {useMutation, useQueryClient} from '@tanstack/react-query';

import {createBanner, CreateBannerParams} from '../api';
import {QUERY__BANNERS} from '../queryKeys';

export const useCreateBanner = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: CreateBannerParams) => createBanner(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({queryKey: [QUERY__BANNERS]});
    },
  });
};
